import { DomainInput } from './DomainInput';

export default DomainInput;
